<template>
	<div>
		<div class="pei-item" :style="'background:'+colorRow.color" @click="onToWebView()">
			<div class="pei-item-top" :style="'color:'+colorRow.color" v-if="row.type=='songpei'">
				送培
			</div>
			<div class="pei-item-top" :style="'color:'+colorRow.color" v-else-if="row.type=='qcxj'">
				七彩星级
			</div>
			<div class="pei-item-top" :style="'color:'+colorRow.color" v-else>
				其他
			</div>
			<div class="pei-item-main">
				<div class="pei-item-city">{{row.city}}</div>
				<div class="pei-item-title show-two-row">{{row.name}}</div>
				<div class="pei-item-time" :style="'background:'+colorRow.color">
					{{getTime(row.startdate)}}~{{getTime(row.enddate)}}</div>

			</div>
			<div class="pei-item-btn">
				<!-- <div class="pei-btn-left" :style="'color:'+colorRow.color2">进入</div> -->
				<div class="pei-btn-right" :style="'color:'+colorRow.color" v-if="getStatus()">报名</div>
				<div class="pei-btn-right" :style="'color:'+colorRow.color" v-else>已结束</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		name: "PeiItem",
		components: {},
		props: {
			row: {
				type: Object,
				default: {}
			},
		},

		data: function() {
			return {
				duration: 300,
				colorRow: {}

			};
		},
		mounted() {
			this.getColor()
		},
		methods: {
			getStatus(){
				if(Date.parse(new Date())/1000 < this.row.etime){
					return true
				}else{
					return false
				}
			},
			onToWebView() {
			  let row = this.row
				if (this.row.type == "songpei") {
					// uni.navigateTo({
					// 	url: '/pages/apps/songpei/SongpeiApplyFormBasic/SongpeiApplyFormBasic?url=https://h5.ccago.cn/cca-h5/dist/songpei-apply-form-basic?'+qs.stringify({saiqu_id: this.row.id})
					// })
					rbLink({
						name: "SongpeiApplyFormBasic",
						query: {
							saiqu_id: row.id
						}
					});
				} else if (this.row.type == "cba") {
					// uni.navigateTo({
					// 	url: '/pages/apps/cba/CbaApplyFormBasic/CbaApplyFormBasic?url=https://h5.ccago.cn/cca-h5/dist/cba-apply-form-basic?'+qs.stringify({station_id: this.row.id})
					// })
					rbLink({
						name: "CbaApplyFormBasic",
						query: {
							station_id: row.id
						}
					});
				} else {
					// uni.navigateTo({
					// 	url: '/pages/apps/huiyi/HuiyiApplyFormStep1/HuiyiApplyFormStep1?url=https://h5.ccago.cn/cca-h5/dist/huiyi-apply-form-step-1?'+qs.stringify({saiqu_id: this.row.id})
					// })
					rbLink({
						name: "HuiyiApplyFormStep1",
						query: {
							saiqu_id: row.id
						}
					});
				}
			},
			onRbLink(item) {
				rbLink({
					name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
					query: item.url.query
				});
			},
			getTime(val) {
				return val.slice(5)
			},
			getColor() {
				let colors = [{
						color: '#FFC34A',
						color2: '#724E04',
						color3: '#A9740D'
					},
					{
						color: '#4EB5FF',
						color2: '#014E85',
						color3: '#1A9FFF'
					},
				]
				this.colorRow = colors[parseInt(Math.random() * 10) % 2]
			},
		},

		filters: {}
	};
</script>

<style scoped>
	.pei-item-time {
		height: .41rem;
		background: #FFC34A;
		line-height: .41rem;
		padding: 0 .24rem;
		background: #FFC34A;
		border-radius: .42rem;
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;

	}

	.pei-item-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.pei-btn-left {
		width: 1.28rem;
		height: .43rem;
		border-radius: .22rem;
		line-height: .43rem;
		text-align: center;
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #724E04;
		background: #FFFFFF;
		opacity: 0.68;
		border: 1px solid #FFFFFF;
		margin: 0 .1rem;
	}

	.pei-btn-right {
		width: 1.28rem;
		height: .43rem;
		background: #FFFFFF;
		border-radius: .22rem;
		border: 1px solid #FFFFFF;
		line-height: .43rem;
		text-align: center;
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #A9740D;
		margin: 0 .1rem;
	}

	.pei-item-title {
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333;
		margin-top: .2rem;
		margin-bottom: .3rem;
	}

	.pei-item-city {
		height: .67rem;
		font-size: .48rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333;
		line-height: .67rem;
		margin-top: -0.2rem;
	}

	.pei-item-main {
		flex: 1;
		background: #fff;
		margin-top: .1rem;
		margin-bottom: .1rem;
		border-radius: .16rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: .1rem;
	}

	.pei-item-time-range {
		height: .3rem;
		font-size: .22rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: .3rem;
	}

	.pei-item-bolid {
		width: 1px;
		height: .16rem;
		opacity: 0.8;
		background: #F2F7FF;
		margin-left: .1rem;
		margin-right: .1rem;
	}

	.pei-item-type {
		width: 1.12rem;
		height: .4rem;
		font-size: .28rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: .4rem;
	}

	.pei-item {
		width: 3.25rem;
		height: 3.66rem;
		background: linear-gradient(226deg, #4BC1FF 0%, #5599FF 100%);
		border-radius: .16rem;
		margin-bottom: .2rem;
		padding: 0 0.1rem;
		display: flex;
		flex-direction: column;
		padding-bottom: .1rem;
	}

	.pei-item-top {
		display: flex;
		align-items: center;
		margin: 0 auto;
		height: .28rem;
		font-size: .2rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFC043;
		line-height: .28rem;
		padding: 0 .3rem;
		background: #FFFFFF;
		border-radius: 0 0 0.1rem 0.15rem;
		margin-top: -0.02rem;
	}

	.show-two-row {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>



// WEBPACK FOOTER //
// PeiItem.vue?3287feee